import { setQuery } from './router';

/**
 * Karte öffnen und schließen über die Adresse. Öffnen legt einen Verlaufseintrag an (Zurück schließt
 * die Karte), Reiterwechsel ersetzen ihn nur. Schließen springt über alle in der App geöffneten
 * Karten zurück – so führt „Zurück“ danach nicht wieder in die Karte.
 */
const depth = () => (typeof history.state?.kabaCard === 'number' ? (history.state.kabaCard as number) : 0);

export function openCard(id: string, opts: { tab?: string; commentId?: string } = {}) {
  const open = new URLSearchParams(location.search).get('card');
  if (open === id) return setQuery({ cardTab: opts.tab ?? null, comment: opts.commentId ?? null }, { replace: true });
  setQuery({ card: id, cardTab: opts.tab ?? null, comment: opts.commentId ?? null }, { state: { kabaCard: open ? depth() + 1 : 1 } });
}

export function closeCard() {
  const d = depth();
  if (d > 0) history.go(-d);
  else setQuery({ card: null, cardTab: null, comment: null });
}

export function setCardTab(tab: string) {
  setQuery({ cardTab: tab === 'uebersicht' ? null : tab, comment: null }, { replace: true });
}
